import type { Competition } from '@/api/spec.ts';

/** Ongoing first, then most recently ended, then soonest upcoming — for the tournament picker. */
export const sortCompetitionsForPicker = (competitions: Competition[] | undefined, nowMs: number): Competition[] => {
  if (!competitions?.length) return [];
  const ongoing = competitions.filter((c) => c.starts_at <= nowMs && nowMs < c.ends_at);
  const ended = competitions.filter((c) => c.ends_at <= nowMs).sort((a, b) => b.ends_at - a.ends_at);
  const upcoming = competitions.filter((c) => c.starts_at > nowMs).sort((a, b) => a.starts_at - b.starts_at);
  return [...ongoing, ...ended, ...upcoming];
};

export const findCompetitionBySlug = (competitions: Competition[] | undefined, slug: string): Competition | undefined =>
  competitions?.find((competition) => competition.slug === slug);

/**
 * Display number for the banner eyebrow ("Perpl Trading Tournament #N"). The backend returns
 * competitions in a guaranteed sequence, so a round's number is its 1-based position in that list.
 */
export const getTournamentNumber = (competitions: Competition[] | undefined, slug: string): number | undefined => {
  const index = competitions?.findIndex((competition) => competition.slug === slug) ?? -1;
  return index === -1 ? undefined : index + 1;
};

/** Config competitions plus supplemental entries (e.g. archived rounds). Config wins on slug conflicts. */
export const mergeCompetitionCatalog = (
  competitions: Competition[] | undefined,
  supplemental: Competition[] = []
): Competition[] => {
  const merged = [...(competitions ?? [])];
  const slugs = new Set(merged.map((competition) => competition.slug));

  for (const competition of supplemental) {
    if (slugs.has(competition.slug)) continue;
    merged.push(competition);
    slugs.add(competition.slug);
  }

  return merged;
};
